import { DRIFT_CHAT_BIONIC_REVIEW_STREAKS_MEASURES } from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

/**
 * Base cube query for bionic ratings streaks.
 */
export const BionicStreaksQuery: CubeQuery = {
  name: 'BionicStreaksQuery',
  queryName: DRIFT_CHAT_BIONIC_REVIEW_STREAKS_MEASURES.STREAK_LENGTH,
  query: {
    measures: [DRIFT_CHAT_BIONIC_REVIEW_STREAKS_MEASURES.STREAK_LENGTH],
  },
}
